var map = {
	"./pingguo1@2x.png": 8029,
	"./pingguo2@2x.png": 5647,
	"./pingguo3@2x.png": 3623,
	"./pingguo4@2x.png": 9902,
	"./pingguo5@2x.png": 7805,
	"./pingguo6@2x.png": 6261,
	"./pingguo7@2x.png": 4506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6386;